import { render, staticRenderFns } from "./Snotify.vue?vue&type=template&id=517284b8&"
import script from "./Snotify.vue?vue&type=script&lang=js&"
export * from "./Snotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports